import axios from 'axios';
import { Message } from 'element-ui';
// import Router from '../router/index.js'
import { utils } from '@/common/common.js'

var baseUrl_local ='http://10.10.1.110:10120'  // 本地
var baseUrl_dev  ='https://api.dev.ysintelligent.com/news_service'  //dev
var baseUrl_test ='https://api.test.ysintelligent.com/news_service'  //test
var baseUrl      ='https://api.ysintelligent.com/news_service'

var uploadUrl_local ='http://10.10.1.110:19999'  // 本地
var uploadUrl_dev  ='https://api.dev.ysintelligent.com/file_service'  //dev
var uploadUrl_test ='https://api.test.ysintelligent.com/file_service'  //test
var uploadUrl      ='https://api.ysintelligent.com/file_service'

var imgPrev_dev='https://static.dev.ysintelligent.com'
var imgPrev_test='https://static.test.ysintelligent.com'
var imgPrev='https://static.ysintelligent.com'

//根据环境 改变接口地址
var environmental= utils.getCurrentApi()
var resultApi={}
if(environmental=='local'){
    resultApi={ //打包时修改成这个,把下面的注释
    	baseUrl: baseUrl_dev, // 陈林
		uploadUrl: uploadUrl_local,
		imgPrev:imgPrev_dev
    }

}
if(environmental=='dev'){
    resultApi={
    	baseUrl: baseUrl_dev,
		uploadUrl: uploadUrl_dev,
		imgPrev:imgPrev_dev
    }
}
if(environmental=='test'){
    resultApi={
    	baseUrl: baseUrl_test,
		uploadUrl: uploadUrl_test,
		imgPrev:imgPrev_test
    }
}
if(environmental=='prod'){
    resultApi={
    	baseUrl: baseUrl,
		uploadUrl: uploadUrl,
		imgPrev:imgPrev
    }
}
export const api = resultApi
export const NEWS_TYPE = 2  // 1 - 亿尚官网    2 - 综合体官网
export const FILE_TYPE = '26201' // 文件类型
var instance = axios.create({
	baseURL: api.baseUrl,
	timeout: 200000,
	// headers: {
	// 	'Content-Type': 'application/x-www-form-urlencoded'
	// }
});

export const ajaxNews = {
	post: function(url, data, headers) {
		let p = new Promise(function(resolve, reject) {
			let params = {
				method: 'post',
				url: url
			}
			if (data) params.data = data
			if (headers) params.headers = headers
			instance(params).then(function(response) {
				// console.log('post', response)
				resolve(response.data)//resolve
			}).catch(function(response) {
				Message({
					message: "服务异常",
					type: 'error',
					duration: 1500
				});
				reject(response.data)//reject
			})
		})
		return p

	},
	get: function(url, data) {
		let args=data
		//promise
		let p = new Promise(function(resolve, reject) {
			instance({
				method: 'get',
				url: url,
				params:args
			}).then(function(response) {
				// console.log('get', response)
				resolve(response.data)//resolve
			}).catch(function(response) {
				Message({
					message: "服务异常",
					type: 'error',
					duration: 1500
				});
				reject(response.data)//reject
			})
		})
		return p
	}
}



// WEBPACK FOOTER //
// ./src/common/request_news.js